<template>
  <!-- 不动产查询结果页 -->
  <div class="mainbox">
    <Head v-if="logo" :logo="logo"></Head>
    <van-tabs
      v-model="active"
      swipeable
      animated
      color="#1989fa"
      @change="change"
      v-if="fromtype==1 || fromtype==4"
    >
      <van-tab v-for="(item,index) in picker" :key="index" :title="item">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" head-height="120">
          <div class="cont">
            <div class="touch"></div>
            <div v-if="dataList.length>0" @touchmove.stop>
              <ListBdc
                :dataList="dataList"
                @func="handleItem(arguments)"
                :checkedMark="checkedMark"
              ></ListBdc>
              <div class="replay" @click="handlePage" v-if="iscode == false">
                <div v-if="hasmore">
                  <div v-if="pageLoading">
                    <van-loading size="24px">加载中...</van-loading>
                  </div>
                  <div v-else>
                    <van-icon name="replay" />点击加载更多数据
                  </div>
                </div>
                <div v-else>暂无更多数据</div>
              </div>
            </div>
            <div v-else class="nodata">
              <van-loading
                size="24px"
                v-if="dataList.length==0 && loading && refreshing==false"
              >加载中...</van-loading>
              <div v-if="dataList.length==0 && !loading">暂无数据</div>
            </div>
          </div>
          <!-- 支付按钮 -->
          <van-button
            round
            block
            type="info"
            v-if="active!=2 &&  dataList.length>0"
            :disabled="usepay?false:true"
            @click="handlePay"
            class="btn"
          >支付</van-button>
          <Foot v-if="list && list.bottomMessage && list.bottomMessage.length>0" :list="list"></Foot>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh" v-else head-height="120">
      <div class="cont">
        <div class="touch"></div>
        <div v-if="dataList.length>0">
          <ListBdc :dataList="dataList" @func="handleItem(arguments)" :checkedMark="checkedMark"></ListBdc>
          <div class="replay" @click="handlePage" v-if="iscode == false">
            <div v-if="hasmore">
              <div v-if="pageLoading">
                <van-loading size="24px">加载中...</van-loading>
              </div>
              <div v-else>
                <van-icon name="replay" />点击加载更多数据
              </div>
            </div>
            <div v-else>暂无更多数据</div>
          </div>
        </div>
        <div v-else class="nodata">
          <van-loading size="24px" v-if="dataList.length==0 && loading && refreshing==false">加载中...</van-loading>
          <div v-if="dataList.length==0 && !loading">暂无数据</div>
        </div>
      </div>
      <!-- 支付按钮 -->
      <van-button
        round
        block
        type="info"
        v-if="isPay && dataList.length>0"
        :disabled="usepay?false:true"
        @click="handlePay"
        class="btn"
      >支付</van-button>
      <Foot v-if="list && list.bottomMessage && list.bottomMessage.length>0" :list="list"></Foot>
    </van-pull-refresh>
    <!-- 弹窗 -->
    <van-dialog v-model="showModel" title="收费项目明细">
      <div class="content">
        <div
          v-for="(item,index) in detailList"
          :key="index"
        >{{item.itemName}}:{{item.actualAmt}}{{item.unit}}</div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showRadio"
      title="请选择批量件模式"
      @confirm="confirmRadio"
      :before-close="beforeCloseRadio"
    >
      <div class="radioContent">
        <van-radio-group v-model="radio">
          <van-radio name="2">开发商模式</van-radio>
          <van-radio name="1">代理商模式</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>

    <van-dialog
      v-model="showPhone"
      title="请输入手机号码"
      @confirm="confirmPhone"
      :before-close="beforeClosePhone"
    >
      <div class="content">
        <van-cell-group>
          <van-field v-model="batchData.phone " label="手机号码" placeholder="请输入手机号码" />
        </van-cell-group>
      </div>
    </van-dialog>

    <div id="widget" />
  </div>
</template>

<script>
import Foot from "@/components/foot";
import Head from "@/components/head";
import List from "@/components/list";
import ListBdc from "@/components/listBdc";
import { Toast, Dialog } from "vant";
import { isEmpty } from "@/utils/common.js";
import { judgeVde } from "@/utils/publicJudge";
let loadedMineMapJs = false;
export default {
  name: "bdcResults",
  components: {
    Foot,
    Head,
    List,
    ListBdc,
  },
  data() {
    return {
      showPhone: false,
      // phone:'',
      showRadio: false,
      radio: "",
      active: 0,
      bizNumber: "",
      payCode: "",
      type: 0,
      vde: "",
      dataList: [],
      isPay: true, //判断是否显示支付按钮
      bizId: "",
      sysType: "",
      sign: "",
      loading: true,
      usepay: true,
      mon: "",
      list: [], //温馨提示列表
      logo: "",
      picker: ["未缴费", "支付中", "已缴费"],
      page: 1,
      limit: 5,
      total: 0,
      hasmore: true,
      pageLoading: false,
      iscode: false, // 是否通过扫码进入
      isSearchHistory: 0, //是否显示已缴费数据
      showModel: false,
      detailList: [],
      refreshing: false,
      showmon: "",
      isBatch: false,
      batchModel: 0,
      index: 0,
      batchData: {
        batchModel: "",
        bizId: "",
        idCard: "",
        paymentUnit: "",
        phone: "",
      },
      checkedMark: "",
    };
  },
  created() {

    this.vde = this.$route.query.vde||'';
    //判断vde
     this.fromtype = this.$route.query.fromtype || '';
    if (this.fromtype!='5') {
      judgeVde({ vde: this.vde }, this);
      this.getFootData();
      this.getHeadImg();
    }
    if (this.$route.query.mon === undefined) {
      this.mon = "";
    } else {
      // 支付之后回调
      this.mon = this.$route.query.mon;
      this.showmon = this.$route.query.mon;
      this.picker = ["未缴费", "支付中", "已缴费"];
      this.active = 2;
      this.type = 1;
    }
    this.bizNumber = this.$route.query.bizNumber;
    this.payCode = this.$route.query.payCode;
    //缴费类型默认为未缴费
    this.bizId = this.$route.query.bizId || "";
    this.sysType = this.$route.query.sysType;
    this.sign = this.$route.query.sign;
    this.batchNo = this.$route.query.batchNo;
    // this.fromtype = this.$route.query.fromtype;
    if (this.fromtype == 1) {
      this.getData(); //查询进入
    }
    if (this.fromtype == 2) {
      this.getQueryData(); //扫码进入
      this.checkedMark = this.bizId;
    }
    if (this.fromtype == 3) {
      this.type = this.$route.query.type;
      this.getNoticeQuery(); //扫码进入
    }
    if (this.fromtype == 4) {
      this.getBdcData();
      this.checkedMark = this.bizId;
    }
    if (this.fromtype == '5') {
      this.getZdyCodeData()
    }

   
  },
  destroyed() {
    Toast.clear();
  },
  methods: {
    // 子传父的参数（用于弹窗）
    handleItem(data) {
      this.showModel = data[0];
      this.detailList = data[1];
    },
    // 下拉刷新
    async onRefresh() {
      this.page = 1;
      this.limit = 5;
      this.dataList = [];
      this.loading = true;

      if (this.fromtype == 1) {
        await this.getData();
      }
      if (this.fromtype == 2) {
        await this.getQueryData();
      }
      if (this.fromtype == 3) {
        await this.getNoticeQuery();
      }
      if (this.fromtype == 4) {
        this.getBdcData();
      }
      this.hasmore = true;
      this.refreshing = false;
      await Toast("刷新成功");
    },

    // 切换导航栏
    change(e) {
      this.dataList = [];
      this.page = 1;
      this.limit = 5;
      if (e == 0) {
        this.type = 0;
        // this.mon = "";
      } else if (e == 1) {
        this.type = 9;
        // this.mon = "";
      } else if (e == 2) {
        this.type = 1;
        /*if (this.showmon && this.isSearchHistory == 1) {
          this.mon = "";
        } else if (this.showmon && this.isSearchHistory == 0) {
          this.mon = this.showmon;
        }*/
      }
      this.hasmore = true;
      if (this.fromtype == 1) {
        this.getData();
      }
      if (this.fromtype == 4) {
        this.getBdcData();
      }
    },
    // 获取头像
     getHeadImg() {
          let data = {}
          data.vde = this.vde;
          this.request({
            url:'/webPortal/websitConfig',
            method:'get',
            params:data
          }).then((res)=>{
              if (res.data.code == 1000 && res.data.result) {
                  if (res.data.result.logoUrlLogin) {
                      this.logo = res.data.result.logoUrlLogin
                  }else {
                    this.logo = require('@/assets/img/logo.png')
                    }
                  sessionStorage.setItem('title',res.data.result.websitTitle)
                  document.title=res.data.result.websitTitle 
              }else if (res.data.code != 1000){
                    this.$router.push({ path: "/404" });
              }
          })
      },
    // 获取底部数据
    getFootData() {
      let data = {
        vde: this.vde,
        type: 6,
      };

      this.request({
        url:'/systemManage/mobileGetMessage',
        method:'get',
        params:data
      }).then((res)=>{
        if (res.data.code != 1000) {
          //this.$router.push({ path: "/404" });
        } else {
          this.list = res.data.result;
          if (this.iscode == false) {
            this.isSearchHistory = res.data.result.isSearchHistory;
            if (this.isSearchHistory == 0) {
              this.picker = ["未缴费", "支付中"];
            }
          }
        }
      })
    },
    // 分页
    handlePage() {
      this.pageLoading = true;
      if (this.dataList.length < this.total) {
        this.page++;
        if (this.fromtype == 1) {
          this.getData();
        }
        if (this.fromtype == 4) {
          this.getBdcData();
        }
      } else {
        setTimeout(() => {
          this.pageLoading = false;
          this.hasmore = false;
        }, 500);
      }
    },
    // 从查询页进来的
    getData() {
      if (this.page == 1) {
        this.dataList = [];
        this.loading = true;
      } else {
        this.pageLoading = true;
      }
      let data = {
        payCode: this.payCode,
        bizNumber: this.bizNumber,
        confirmType: this.type,
        vde: this.vde,
        mon: this.mon,
        page: this.page,
        limit: this.limit,
      };
      return new Promise((resolve) => {
        this.request({
          url:'/mobile/queryBdcData',
          method:'get',
          params:data
        }).then((res)=>{
          this.loading = false;
          this.pageLoading = false;
          if (res.data.code == 1000) {
            if (res.data.result != null) {
              this.dataList = this.dataList.concat(res.data.result.list);
              this.total = res.data.result.total;
              this.isPay = this.dataList.some((val) => {
                return val.isConfirm != 1;
              });
            }
            this.$forceUpdate();
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            }).then(() => {});
          }
          resolve();

        })
      });
    },
    // 扫码进入的
    getQueryData() {
      this.iscode = true;
      let data = {
        bizId: this.bizId,
        sign: this.sign,
        vde: this.vde,
      };
      this.request({
        url:'/mobile/qrcodeQueryBdcData',
        method:'get',
        params:data
      }).then((res)=>{
          this.loading = false;
          if (res.data.code == 1000) {
            this.dataList = res.data.result.list;
            this.isPay = this.dataList.some((val) => {
              return val.isConfirm != 1;
            });
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            }).then(() => {});
          }
      })
    },
    //告知单扫描进入
    getNoticeQuery() {
      this.iscode = true;
      let data = {
        bizNumber: this.bizNumber,
        vde: this.vde,
        confirmType: this.type,
      };
      this.request({
        url:'/mobile/queryBdcData',
        method:'get',
        params:data
      }).then((res)=>{
        this.loading = false;
        this.pageLoading = false;
        if (res.data.code == 1000) {
          if (res.data.result != null) {
            this.dataList = this.dataList.concat(res.data.result.list);
            this.total = res.data.result.total;
            this.isPay = this.dataList.some((val) => {
              return val.isConfirm != 1;
            });
          }
          this.$forceUpdate();
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.message,
          }).then(() => {});
        }

      })
    },
    // 接口进来的不动产数据
    getBdcData() {
      let data = {
        batchNo: this.batchNo,
        confirmType: this.type,
        limit: this.limit,
        page: this.page,
        bizId: this.bizId,
        sign: this.sign,
        vde: this.vde,
      };
      this.request({
        url:'/mobile/queryInterfaceBdcData',
        method:'get',
        params:data
      }).then((res)=>{
          this.loading = false;
          if (res.data.code == 1000) {
            this.dataList = res.data.result.list;
            this.isPay = this.dataList.some((val) => {
              return val.isConfirm != 1;
            });
            if (isEmpty(this.checkedMark) && this.dataList.length == 1) {
              this.checkedMark = this.dataList[0].uId;
            }
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            }).then(() => {});
          }

      })
    },
    // 不动产自定义二维码
    getZdyCodeData() {
      let data = {
        appId:this.$route.query.appId||'',
        data:this.$route.query.data||'',
       
      };
      this.loading = true;
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url:'/gzbdc_pay/getQrcodeData',
        method:'get',
        params:data
      }).then((res)=>{
          this.loading = false;
          if (res.data.code == 1000) {
            this.dataList = res.data.result.pageInfo.list;
            this.vde = res.data.result.vde;
            this.isPay = this.dataList.some((val) => {
              return val.isConfirm != 1;
            });
            if (isEmpty(this.checkedMark) && this.dataList.length == 1) {
              this.checkedMark = this.dataList[0].uId;
            }
            judgeVde({ vde: this.vde }, this);
            this.getFootData();
            this.getHeadImg();
          } else {
            Dialog.alert({
              title: "提示",
              message: res.data.message,
            }).then(() => {});
          }

      })
    },

    handlePay() {
      let noticeNo = "";
      let sysType = "";
      let payAmt = "";
      let bool = this.dataList.some((val) => {
        return val.checked;
      });

      if (bool) {
        // 批量件支付传参
        this.usepay = false;
        this.dataList.forEach((val, index) => {
          if (val.checked == true) {
            if (val.batchModel != "3") {
              this.batchModel = val.batchModel;
              this.index = index;
              this.isBatch = true;
              this.batchData.batchModel = val.batchModel;
              this.batchData.bizId = val.uId;
              this.batchData.idCard = val.idCard ? val.idCard : "";
              this.batchData.paymentUnit = val.paymentUnit;
              this.batchData.phone = val.phone ? val.phone : "";
            } else if (val.batchModel == "3") {
              this.isBatch = false;
            }
            noticeNo = val.noticeNo;
            payAmt = val.paymentTotal;
            if (val.sysType == 1) {
              sysType = 1;
            } else {
              sysType = 2;
            }
          }
        });
        let data = {
          noticeNo: noticeNo,
          sysType: sysType,
          payAmt: payAmt,
          deviceType: "phone",
        };
        if (this.type == 9) {
          Dialog.confirm({
            title: "提示",
            message: "订单状态为支付中，确认继续支付？",
          })
            .then(() => {
              if (this.isBatch == false) {
                this.pay(data);
              } else if (this.isBatch == true) {
                if (this.batchModel == 4) {
                  this.showRadio = true;
                } else {
                  this.batchPay();
                }
              }
            })
            .catch(() => {
              this.usepay = true;
            });
        } else {
          if (this.isBatch == false) {
            this.pay(data);
          } else if (this.isBatch == true) {
            if (this.batchModel == 4) {
              this.showRadio = true;
            } else {
              this.batchPay();
            }
          }
        }
      } else {
        Dialog.alert({
          title: "提示",
          message: "请选择需要缴费的项目",
        }).then(() => {});
      }
    },
    confirmRadio() {
      if (this.radio != "") {
        this.batchData.batchModel = this.radio;
        if (this.radio == "2") {
          if (this.dataList[this.index].phone == null) {
            this.showPhone = true;
          } else {
            Dialog.confirm({
              title: "提示",
              message: "是否更改手机号码",
            })
              .then(() => {
                this.showPhone = true;
              })
              .catch(() => {
                this.batchPay(1);
              });
          }
        } else if (this.radio == "1") {
          this.batchPay(1);
        }
      }
    },
    confirmPhone() {
      if (/^1\d{10}$/.test(this.batchData.phone)) {
        this.batchPay(2);
      }
    },
    beforeCloseRadio(action, done) {
      if (this.radio == "") {
        Toast("请选择批量件模式");
        done(false);
      } else {
        done();
      }
    },
    beforeClosePhone(action, done) {
      if (this.batchData.phone == "") {
        Toast("请输入手机号码");
        done(false);
      } else if (/^1\d{10}$/.test(this.batchData.phone) == false) {
        Toast("手机号码格式不正确");
        done(false);
      } else {
        done();
      }
    },
    batchPay(type) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      //请求支付接口
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url:'/pay/payInitBatch',
        method:'post',
        data:this.batchData
      }).then((res)=>{
        if (type == 1) {
          this.dataList[this.index].batchModel = this.batchData.batchModel;
          this.$forceUpdate();
        } else if (type == 2) {
          this.dataList[this.index].batchModel = this.batchData.batchModel;
          var str = this.batchData.phone;
          var pat = /(\d{3})\d*(\d{4})/;
          var b = str.replace(pat, "$1****$2");
          this.dataList[this.index].phone = b;
          this.$forceUpdate();
        }
        if (res.data.code == 1000) {
          //未加载成功
          if (!loadedMineMapJs) {
            this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
              loadedMineMapJs = true;
              this.otherPay(res.data.result);
            });
            // 已经加载成功
          } else {
            this.otherPay(res.data.result);
          }
        } else if (res.data.code == 201) {
          Toast.clear();
          Dialog.alert({
            title: "提示",
            message: res.data.message,
          }).then(() => {
            this.usepay = true;
          });
        }
        
      })
    },
    pay(data) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      // 请求支付接口
      this.request({
        baseURL: process.env.VUE_APP_PAY_URL,
        url:'/epay/pay_init',
        method:'get',
        params:data
      }).then((res)=>{
        if (res.data.code == 1000) {
          //未加载成功
          if (!loadedMineMapJs) {
            this.asyncLoadJs(res.data.result.thirdpayWidgetJs).then(() => {
              loadedMineMapJs = true;
              this.otherPay(res.data.result);
            });
            // 已经加载成功
          } else {
            this.otherPay(res.data.result);
          }
        } else {
          Toast.clear();
          Dialog.alert({
            title: "提示",
            message: res.data.message,
          }).then(() => {
            this.usepay = true;
          });
        }

      })
    },
    otherPay(res) {
      let obj = {
        container: "widget", // 挂件在当前页面放置的控件ID
        merchant_no: res.merchant_no, // 分配的商户号
        merchant_order_no: res.merchant_order_no, // 订单在商户系统中的订单号
        amount: res.amount, // 订单价格，单位：人民币 分
        widget_param: res.widget_param,
        subject: res.subject,
        body: res.body,
        charge_url: res.charge_url, // 商户服务端创建Charge字符串的url
        charge_param: res.charge_param,
        device_type: res.device_type, // 设备类型
        effective_time: res.effective_time, // 当天有效，24点失效
        version_no: res.version_no,
      };
      let that = this;
      const interval = setInterval(() => {
        if (loadedMineMapJs) {
          clearInterval(interval);
          // 调起支付
          thirdpay_widget.init(obj);
          Toast.clear();
          that.usepay = true;
        }
      }, 100);
    },
    asyncLoadJs(url) {
      var Q = require("q");
      return Q.Promise((resolve, reject) => {
        let srcArr = document.getElementsByTagName("script");
        let hasLoaded = false;
        for (let i = 0; i < srcArr.length; i++) {
          //判断当前js是否加载上
          hasLoaded = srcArr[i].src == url ? true : false;
        }
        if (hasLoaded) {
          resolve();
          return;
        }
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.src = url;
        document.body.appendChild(script);
        script.onload = () => {
          resolve();
        };
        script.onerror = () => {
          reject();
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.mainbox {
  padding: 0 2vw;
  box-sizing: border-box;
}
.nodata {
  text-align: center;
  font-size: 15px;
  margin: 30px 0;
  color: #888;
}
.cont {
  margin-top: 10px;
  position: relative;
  .replay {
    text-align: center;
    color: #999;
  }
  .touch {
    height: 30vh;
    width: 100vw;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 10;
  }
}
.content {
  text-align: center;
  padding: 15px 0;
  line-height: 24px;
}
.radioContent {
  padding: 15px 0 0 100px;
  .van-radio {
    text-align: center;
    margin-bottom: 10px;
  }
}
.btn {
  margin-top: 20px;
}
</style>
